<template>
  <div>
    <el-row>
      <el-button type="primary" @click="onClickBtn" v-show="showBtn">补签未报名学员</el-button>

      <template v-if="!showBtn">
        <el-row type="flex">
          <PersonSelectOwn @onValueChanged="onPersonValueChanged"></PersonSelectOwn>
          <el-button type="primary" class="ml-5" v-if="uid" :loading="loading" @click="confirm">确定</el-button>
        </el-row>
      </template>
    </el-row>
    <el-row class="mt-5" v-if="studyClassInfo.showlevel != 0">
        <el-button @click="onClickAll" >进入补签详细信息页面</el-button>
    </el-row>
  </div>
</template>
<script>
import { BaseVue } from "@/mixin/index";
import { PersonSelect, PersonSelectOwn } from "@/views/components/select";
import { fillCheckDirectApi } from "@/api/module/fillcheck/fillcheck";

export default {
  name: "FillCheckUnSignUp",
  
  mixins: [BaseVue],
  
  components: {
    PersonSelectOwn
  },
  
  props: {
    sid: {
      type: String,
      default: ""
    },
    showlevel: {
      type: [String, Number, Boolean, Object, Array],
      default: null
    }
  },
  
  data() {
    return {
      id: "",
      tableData: [],
      studyClassInfo: {},
      uid: "",
      showBtn: true,
      loading: false
    };
  },
  
  methods: {
    init() {
      // 初始化逻辑
    },
    
    clickBuqian(index, row) {
      // 补签逻辑
    },
    
    onClickBtn() {
      this.showBtn = !this.showBtn;
    },
    
    onClickAll() {
      this.$router.push({
        path: '/fillcheck/all',
        query: {
          id: this.id
        }
      });
    },
    
    onPersonValueChanged(value) {
      console.log("onPersonValueChanged", value);
      this.uid = value;
    },
    
    confirm() {
      this.loading = true;
      
      fillCheckDirectApi(this.uid, this.sid)
        .then(() => {
          this.$message.success("补签成功！");
          this.showBtn = true;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  
  mounted() {
    this.id = this.$route.query.id;
    this.init();
  }
};
</script>


<style scoped lang="scss">
.box-card {
  margin-bottom: 20px;
  .top_info {
    display: flex;
    div {
      font-size: 15px;
      margin-right: 30px;
    }
  }
  .classTitle {
    font-size: 16px;
    color: #303133;
    font-weight: 600;
    padding-top: 20px;
    border-top: 1px dotted #ddd;
  }
  .oneItem{
    border-top: 1px dotted #ddd;
    padding-top: 15px;
  }
  .title {
    color: #000;
    font-weight: 500;
    display: inline-block;
    font-size: 15px;
    width: 105px;
  }
  .cont {
    color: #3e3e3e;
    font-size: 15px;
  }
}
.clearfix {
  font-size: 16px;
  color: #303133;
  font-weight: 600;
}
</style>